import { render, staticRenderFns } from "./#file-detail.vue?vue&type=template&id=6d594500&"
import script from "./#file-detail.vue?vue&type=script&lang=js&"
export * from "./#file-detail.vue?vue&type=script&lang=js&"
import style0 from "./#file-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports